<script setup lang="ts">
</script>

<template>
    <header
        class="w-full h-[90px] flex justify-center relative"
    >
        <div class="flex-grow flex justify-end h-full">
            <slot></slot>
        </div>
    </header>
</template>

<style scoped></style>
